import { useGame } from "@/contexts/GameContext";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { occasions } from "@/lib/constants";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";

export default function OccasionStep() {
  const { state, dispatch } = useGame();
  const currentOccasions = state.settings?.occasions || [];

  const toggleOccasion = (occasionId) => {
    const newOccasions = currentOccasions.includes(occasionId)
      ? currentOccasions.filter((o) => o !== occasionId)
      : [...currentOccasions, occasionId];

    dispatch({ type: "UPDATE_SETTINGS", payload: { occasions: newOccasions } });
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        {occasions.map((occasion) => {
          const Icon = occasion.icon;
          const isSelected = currentOccasions.includes(occasion.id);

          return (
            <Button
              key={occasion.id}
              onClick={() => toggleOccasion(occasion.id)}
              size="lg"
              variant="outline"
              className={cn(
                "whitespace-normal relative bg-card/60 backdrop-blur-sm h-auto p-3 rounded-xl outline transition-all duration-200 flex flex-col items-center gap-2",
                isSelected ? "outline-primary/50" : "outline-none"
              )}
            >
              <Icon className="size-7" />
              <span className="font-semibold text-sm">{occasion.name}</span>

              {/* Wskaźnik zaznaczenia */}
              {isSelected && (
                <motion.div
                  initial={{ scale: 0.5, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  className="absolute z-10 top-2 right-2 size-5 bg-primary rounded-full flex items-center justify-center"
                >
                  <Check className="size-3 text-white" />
                </motion.div>
              )}
            </Button>
          );
        })}
      </div>

      {currentOccasions.length === 0 && (
        <div className="text-center mt-4">
          <p className="text-sm text-yellow-600 dark:text-yellow-400">
            Wybierz przynajmniej jedną okazję
          </p>
        </div>
      )}
    </div>
  );
}
